import { useState } from 'react';
import { useEventListener } from 'src/utils/hooks';

export const MOBILE_PAGE_MESSAGE_TYPES = {
  mobilePageResize: 'MOBILE_PAGE_RESIZE',
};

export const useMobilePageIframe = () => {
  const [iframeHeight, setIframeHeight] = useState('100%');

  useEventListener({
    target: window,
    eventName: 'message',
    callback: (event) => {
      const data = event?.data;

      if (!data) return;

      switch (data.type) {
        case MOBILE_PAGE_MESSAGE_TYPES.mobilePageResize: {
          setIframeHeight(data.height);
          break;
        }
        default:
          break;
      }
    },
  });

  return { iframeHeight };
};
